import BaseComponent from '@/components/base';

export default class ProductDescription extends BaseComponent {
  onConstruct() {}

  afterMount() {}

  render() {
    return `
      <style>
        h1 {
          font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;;
          font-size: 50px;
          font-weight: 400;
          line-height: 54px;
          margin: 0;
        }
        p {
          font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
          font-size: 16px;
        }
        @media (max-width: 900px) {
          p {
            font-size: 14px;
          }
        }
      </style>
      <section>
        <h1>${this.title}</h1>
        <slot></slot>

        <!-- <p>${this.description}</p> -->
      </section>
    `;
  }

  get title() {
    return this.getAttribute('title');
  }

  get description() {
    return this.getAttribute('description');
  }

  get productReviews() {
    return this.data.productReviews.value;
  }
}
